import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import { Male, Female, Groups } from "@mui/icons-material";

const DemographicTable = ({ header, values }) => {
  const getRowColor = (index) => {
    return index % 2 === 0 ? "bg-gray-50" : "bg-white";
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat("pt-BR").format(num);
  };

  return (
    <div className="h-full max-h-[26rem] overflow-hidden flex flex-col">
      <TableContainer
        component={Paper}
        elevation={0}
        className="flex-1 overflow-auto border border-gray-200 rounded-lg"
        sx={{ maxHeight: "24rem" }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell
                className="bg-emerald-50 border-b border-emerald-200"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  color: "#047857",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  padding: "12px 8px",
                }}
              >
                <div className="flex items-center space-x-2">
                  <Groups className="h-4 w-4" />
                  <span>Faixa Etária</span>
                </div>
              </TableCell>
              <TableCell
                align="center"
                className="bg-emerald-50 border-b border-emerald-200"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  color: "#047857",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  padding: "12px 8px",
                }}
              >
                <div className="flex items-center justify-center space-x-2">
                  <Male className="h-4 w-4" />
                  <span>Masculino</span>
                </div>
              </TableCell>
              <TableCell
                align="center"
                className="bg-emerald-50 border-b border-emerald-200"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  color: "#047857",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  padding: "12px 8px",
                }}
              >
                <div className="flex items-center justify-center space-x-2">
                  <Female className="h-4 w-4" />
                  <span>Feminino</span>
                </div>
              </TableCell>
              <TableCell
                align="center"
                className="bg-emerald-50 border-b border-emerald-200"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  color: "#047857",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  padding: "12px 8px",
                }}
              >
                <div className="flex items-center justify-center space-x-2">
                  <Groups className="h-4 w-4" />
                  <span>Total</span>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {header.map((faixa, idx) => (
              <TableRow
                key={idx}
                className={`hover:bg-emerald-50 transition-colors duration-200 ${getRowColor(
                  idx
                )}`}
                sx={{
                  "&:hover": {
                    backgroundColor: "#ecfdf5",
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "12px 8px",
                    fontWeight: 500,
                    color: "#374151",
                  }}
                >
                  <Chip
                    label={faixa}
                    size="small"
                    className="bg-gray-100 text-gray-700 font-medium"
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "#374151",
                      fontWeight: 500,
                    }}
                  />
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: "12px 8px",
                    color: "#1f2937",
                    fontWeight: 500,
                  }}
                >
                  <span className="text-blue-600 font-semibold">
                    {formatNumber(values.masculino[idx])}
                  </span>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: "12px 8px",
                    color: "#1f2937",
                    fontWeight: 500,
                  }}
                >
                  <span className="text-pink-600 font-semibold">
                    {formatNumber(values.feminino[idx])}
                  </span>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: "12px 8px",
                    color: "#1f2937",
                    fontWeight: 600,
                  }}
                >
                  <Chip
                    label={formatNumber(values.total[idx])}
                    size="small"
                    className="bg-emerald-100 text-emerald-800 font-semibold"
                    sx={{
                      backgroundColor: "#d1fae5",
                      color: "#065f46",
                      fontWeight: 600,
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div className="mt-4 p-3 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-lg border border-emerald-200">
        <Typography
          variant="caption"
          className="text-emerald-700 font-medium block text-center"
        >
          Total de {header.length} faixas etárias analisadas
        </Typography>
      </div>
    </div>
  );
};

export default DemographicTable;
